import { Carousel } from '@mantine/carousel';
import { Button, Image, Paper, Text, Title, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import classes from './CardsCarousel.module.css';

function Card({ image, title, category }) {
  return (
    <Paper
      shadow="md"
      p="xl"
      radius="md"
      
      className={classes.card}
    >
      <div>
      <Image src={image} className={classes.imagecatogiry}/>
        <Text className={classes.category} size="xs">
          {category}
        </Text>
        <Title order={3} className={classes.title}>
          {title}
        </Title>
      </div>
      
    </Paper>
  );
}

const data = [
  {
    image:
      'https://piloggroup.com/img/Products/ispir/functionality-icon1.svg',
    title: 'Organization and Project Setup with all the Related Participants',
   
  },
  {
    image:
      'https://piloggroup.com/img/Products/ispir/functionality-icon2.svg',
    title: 'Vendor Registration',
    
  },
  {
    image:
      'https://piloggroup.com/img/Products/ispir/functionality-icon3.svg',
    title: 'Purchase Order Registration',
   
  },
  {
    image:
      'https://piloggroup.com/img/Products/ispir/functionality-icon4.svg',
    title: 'SPIR Registration with the associated SPDP Requirements and Attachments',
   
  },
  {
    image:
      'https://piloggroup.com/img/Products/ispir/functionality-icon5.svg',
    title: 'SPIR and Document Control',
    
  },
  {
    image:
      'https://piloggroup.com/img/Products/ispir/functionality-icon6.svg',
    title: 'SPIR Approval Workflow',
    
  },
  {
    image:
      'https://piloggroup.com/img/Products/ispir/functionality-icon7.svg',
    title: 'Detect and Resolve Project and Existing Product duplicate items',
    
  },
  {
    image:
      'https://piloggroup.com/img/Products/ispir/functionality-icon8.svg',
    title: 'Cataloguing, Classification and Standardization',
    
  },
  {
    image:
      'https://piloggroup.com/img/Products/ispir/functionality-icon9.svg',
    title: 'Equipment Registration',
    
  },
];


export const CarouselComponent = () => {
    const theme = useMantineTheme();
    const mobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
  
    const slides = data.map((item) => (
      <Carousel.Slide key={item.title}>
        <Card image={item.image} title={item.title} category={item.category} />
      </Carousel.Slide>
    ));
  
    return (
      <Carousel
        slideSize={{ base: '100%', sm: '33.333%' }}
        slideGap={{ base: 2, sm: 'xl' }}
        align="start"
        slidesToScroll={mobile ? 1 : 3}
      >
        {slides}
      </Carousel>
    );
  }